// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bx","header":"by","subHeader":"bz","content":"bA","iframeWrapper":"bB","cta":"bC","alertMessage":"bD"};